// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Lens_Record = require("../Data.Lens.Record/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Username = function (x) {
    return x;
};
var Email = function (x) {
    return x;
};
var newtypeUsername = new Data_Newtype.Newtype(function (n) {
    return n;
}, Username);
var newtypeEmail = new Data_Newtype.Newtype(function (n) {
    return n;
}, Email);
var genericUsername = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showUsername = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericUsername)(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "Username";
}))));
var genericEmail = new Data_Generic_Rep.Generic(function (x) {
    return x;
}, function (x) {
    return x;
});
var showEmail = new Data_Show.Show(Data_Generic_Rep_Show.genericShow(genericEmail)(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showString))(new Data_Symbol.IsSymbol(function () {
    return "Email";
}))));
var eqUsername = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordUsername = new Data_Ord.Ord(function () {
    return eqUsername;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var eqEmail = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordEmail = new Data_Ord.Ord(function () {
    return eqEmail;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordString)(x)(y);
    };
});
var encodeJsonUsername = Data_Argonaut_Encode_Class.encodeJsonJString;
var encodeJsonEmail = Data_Argonaut_Encode_Class.encodeJsonJString;
var decodeJsonUsername = Data_Argonaut_Decode_Class.decodeJsonString;
var decodeJsonEmail = Data_Argonaut_Decode_Class.decodeJsonString;
var _username = function (dictStrong) {
    return Data_Lens_Record.prop(new Data_Symbol.IsSymbol(function () {
        return "username";
    }))()()(Data_Symbol.SProxy.value)(dictStrong);
};
module.exports = {
    Username: Username,
    Email: Email,
    "_username": _username,
    newtypeEmail: newtypeEmail,
    genericEmail: genericEmail,
    eqEmail: eqEmail,
    ordEmail: ordEmail,
    encodeJsonEmail: encodeJsonEmail,
    decodeJsonEmail: decodeJsonEmail,
    showEmail: showEmail,
    newtypeUsername: newtypeUsername,
    genericUsername: genericUsername,
    eqUsername: eqUsername,
    ordUsername: ordUsername,
    encodeJsonUsername: encodeJsonUsername,
    decodeJsonUsername: decodeJsonUsername,
    showUsername: showUsername
};
